import {
  acceptInvite,
  forgetPassword,
  googleLogin,
  linkedinLogin,
  loginUser,
  logoutUser,
  resetPassword,
  validateInvite,
} from "@/services/authService";
import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { AxiosError } from "axios";

export const useLogin = (): UseMutationResult<
  IResponse,
  AxiosError<IErrorResponse>,
  IPropsLoginForm
> => {
  return useMutation<IResponse, AxiosError<IErrorResponse>, IPropsLoginForm>({
    mutationFn: loginUser,
  });
};

export const useLogout = (): UseMutationResult<
  ISuccessResponse,
  AxiosError,
  IPropsLogout
> => {
  return useMutation<ISuccessResponse, AxiosError, IPropsLogout>({
    mutationFn: logoutUser,
  });
};

export const useValidateInvite = (): UseMutationResult<
  ValidateInviteResponse,
  AxiosError<IErrorResponse>,
  string
> => {
  return useMutation<ValidateInviteResponse, AxiosError<IErrorResponse>, string>({
    mutationFn: validateInvite,
  });
};

export const useAcceptInvite = (): UseMutationResult<
  InviteResponse,
  AxiosError<IErrorResponse>,
  AcceptInvitePayload
> => {
  return useMutation<
    InviteResponse,
    AxiosError<IErrorResponse>,
    AcceptInvitePayload
  >({
    mutationFn: acceptInvite,
  });
};

export const useResetPassword = (): UseMutationResult<
  ISuccessResponse,
  AxiosError<IErrorResponse>,
  {
    password: string;
    confirm_password: string;
    token: string;
    first_name?: string;
    last_name?: string;
    phone?: string;
  }
> => {
  return useMutation<
    ISuccessResponse,
    AxiosError<IErrorResponse>,
    {
      password: string;
      confirm_password: string;
      token: string;
      first_name?: string;
      last_name?: string;
      phone?: string;
    }
  >({
    mutationFn: resetPassword,
  });
};

export const useGoogleLoginMutation = (): UseMutationResult<
  {
    access: string;
    refresh: string;
    user: UserProfile;
  },
  AxiosError<IErrorResponse>,
  string
> => {
  return useMutation<
    {
      access: string;
      refresh: string;
      user: UserProfile;
    },
    AxiosError<IErrorResponse>,
    string
  >({
    mutationFn: googleLogin,
  });
};

export const useLinkedinLoginMutation = (): UseMutationResult<
  {
    access: string;
    refresh: string;
    user: UserProfile;
  },
  AxiosError<IErrorResponse>,
  string
> => {
  return useMutation<
    {
      access: string;
      refresh: string;
      user: UserProfile;
    },
    AxiosError<IErrorResponse>,
    string
  >({
    mutationFn: linkedinLogin,
  });
};

export const useForgetPasswordMutation = (): UseMutationResult<
  ISuccessResponse,
  AxiosError<IErrorResponse>,
  string
> => {
  return useMutation<ISuccessResponse, AxiosError<IErrorResponse>, string>({
    mutationFn: forgetPassword,
  });
};
